export const Colors = {
  primaryLight: "#E0FCEF",
  primary: "#1ABB9C",
  primaryDarker: "#068068",
  primaryDarkest: "#003329",
  primaryDisabled: "rgba(26, 187, 156, 0.5)",
  secondary: "#2A3F54",
  secondaryLight: "#E9E9E9",
  deletePrimaryLight: "#FDDBDB",
  deletePrimary: "#F32D2D",
  deleteprimaryDarker: "#CA2525",
  deleteprimaryDarkest: "#A21E1E",
  glassRed: "#FFE7E6",
  offwhite: "#F7F7F9",
  dark: "#232325",
  light: "#FFFFFF",
  buttonText: "#F2F2F2",
  placeholder: "#747474",
  black: "#000000",
  neutral: "#555555",
  stroke: "rgba(0, 0, 0, 0.10)",
  greyLight: "#808080",
  greyLightest: "#EEF0F2",
  skin: "#87592F",
  labelColor: "#777777",
  greyText: "#757575",
  textColor: "#333333",
  tablecellColor: "rgba(0, 0, 0, 0.87)",
  tableHeadColor: "rgba(0, 0, 0, 0.56)",
  borderColor: "#D4D4D4",
  buttonError: "#CA2525",
  buttonWarning: "#D1AC32",
  buttonSuccess: "#60925B",
  disabled: "hsl(212.3, 16.7%, 93.4%)",
}
